import { RegistrationSource } from '../../models/registration/registration-source.enum';
import { RegistriaRequestRegisteredItem } from '../../models/registria/registria-request-registered-item.interface';

export const mockRegistriaRequestRegisteredItem: RegistriaRequestRegisteredItem =
  {
    product_sku: 'WRF736SDAM',
    purchase_date: '2025-01-04',
    serial_number: 'K70319827',
    brand: 'maytag',
    source: RegistrationSource.PR,
  };
